<template>
  <v-dialog max-width="450" v-model="dialog">
    <v-card light class="hr-already-exists-dialog">
      <v-btn class="dialog-close" icon @click="$emit('close')">
        <v-icon>$close</v-icon>
      </v-btn>
      <v-card-text>
        <div class="hr-already-exists-dialog__title">
          This Hire Request Already Exists
        </div>
        <div v-if="mondayComItemId" class="hr-already-exists-dialog__body">
          <p>
            A Hire Request with #{{ mondayComItemId }} has already been
            created.<br />
            <router-link :to="`/hire-requests/${mondayComItemId}`">
              View that Hire Request here</router-link
            >
          </p>
        </div>
        <div v-else>Something went wrong.</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    mondayComItemId: String,
  },
};
</script>

<style lang="scss" scoped>
.hr-already-exists-dialog {
  color: #262729;
  padding: 35px;
  text-align: center;

  &__title {
    font-size: 20px;
    font-weight: 900;
    color: #262729;
    padding: 30px 0 20px !important;
  }
  &__body {
    font-size: 16px;
  }
}
</style>
